'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidHangout = function IoAndroidHangout(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c7.5 0 13.7 6 13.7 13.4 0 7.1-5.9 15.3-13.7 19.1v-5.6c-7.6 0-13.8-6.1-13.8-13.5s6.2-13.4 13.8-13.4z m-0.8 14.2v-4.7h-4.9v4.7h2.4l-1.6 3.2h2.4z m6.4 0v-4.7h-4.9v4.7h2.5l-1.6 3.2h2.4z' })
        )
    );
};

exports.default = IoAndroidHangout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-hangout.js
// module id = 1867
// module chunks = 0